import React from "react";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { Col, Container, Row } from "react-bootstrap";
import faq from "../assets/images/faq-1.jpg";

function About() {
  return (
    <Wrapper>
      <Herosection title={"About"} />
      <div id="aboutssWrapper">
        <Container>
          <Row className="py-5 gap-5">
            <Col lg={5} className="py-5" data-aos="fade-right">
              <div className="overflow-hidden ratio-1x1 rati rounded-4">
                <img className="img-fluid" src={faq} alt="" />
              </div>
            </Col>
            <Col lg={6} className="py-5" data-aos="fade-left">
              <div className="faq-data">
                <p className="fw-bold">About the Founder</p>
                <div className="content">
                  Yashraj Nigade, the founder of the BCA Study website, has a
                  background in computer applications, holding a Bachelor of
                  Computer Applications (BCA) degree. During his studies,
                  Yashraj faced significant challenges due to the lack of
                  adequate study materials. Motivated by this experience, he
                  meticulously created handwritten notes for all semesters,
                  ensuring comprehensive coverage of the curriculum. <br />{" "}
                  Currently working as a software developer, Yashraj's mission
                  with BCA Study is to provide future BCA students with easily
                  accessible, high-quality study resources, sparing them the
                  difficulties he encountered. His dedication mirrors the
                  efforts of other educational resource creators like Sonoo
                  Jaiswal, who developed Javatpoint to help students learn
                  computer science technologies through detailed tutorials and
                  practical examples. <br /> Yashraj's initiative aims to bridge
                  the gap in educational resources, making learning more
                  efficient and less stressful for BCA students. His handwritten
                  notes serve as a valuable tool for students seeking to excel
                  in their studies and better prepare for their future careers
                  in the tech industry.
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Wrapper>
  );
}

export default About;
